<div class="popup-header">
  <span style="padding-left:10px">{{title}} Group: {{groupname}}</span>

  <div (click)="closePopup()" class="back">
    <mat-icon class="cancel-icon">cancel</mat-icon>
  </div>
</div>
<mat-dialog-content>
  <div style="padding-top: 15px; width: 100%;">
    <mat-select multiple name="groupperson" [ngModelOptions]="{ standalone: true }" (keydown)="$event.stopPropagation()"
      (selectionChange)="addPeople($event)" [(ngModel)]="selectedPersons" class="form-control"
      placeholder="Search by Name/Mail (min 4 chars)" panelClass="remove-input-margin">
      <input (keydown)="$event.stopPropagation()" [ngModelOptions]="{ standalone: true }" (keyup)="loadPeople()" name="appsearch" matInput type="text"
        class="form-control" [(ngModel)]="msfilter" (blur)=resetValue()/>
      <mat-option [ngValue]="undefined" hidden></mat-option>
      <mat-option [disabled]="!row.mail" title="{{ row.msid }}" [value]="row.mail" *ngFor="let row of people">
        {{ row.cn }}<{{ row.givenName }}>({{ row.mail }})
      </mat-option>
    </mat-select>
  </div>
  <div class="group-btn-transfer" style="padding-top: 15px;">
    <ng-container>
      <button class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button" (click)="shareOrTransfer()">{{title}}</button>
    </ng-container>
  </div>

</mat-dialog-content>
